<template>
    <div class="landing-logo" @click="handleLanding">
        <img src="@/assets/BaseLogo-ThumbCircle.png" alt="Pickled.App" />
    </div>
    <div class="landing-heading">{{ t('welcome') }}</div>
    <div class="landing-subheading">{{ t('theBestPlayground') }}&trade;</div>
    <div class="landing-founded">Since 2022</div>

</template>

<script>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from "vue-router";
export default {
    name: 'LogoHeading',
    setup() {
        const router = useRouter();
        const { t } = useI18n();
        const handleLanding = () => {
            router.push("/landing");
        };

        return {
            t,
            handleLanding
        };
    }
};
</script>
<style scoped>

</style>
